import api from './api';

const timesheetsDashboardService = {
  // Get timesheets dashboard statistics
  getDashboardStats: async () => {
    try {
      const response = await api.get('/timesheets-dashboard/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching timesheets dashboard stats:', error);
      throw error;
    }
  }
};

export default timesheetsDashboardService;

